import { EventInput } from "@fullcalendar/core/index.js";
import { Task } from "../types/task";
import { ConfirmedDeal } from "../types/empresa";


export const parseTasksToEvents = (tasks: Task[]): EventInput[] => {
    const events: EventInput[] = [];
    tasks.map((task) => {
        events.push({
            id: task.id.toString(),
            title: task.titulo,
            start: task.fechaInicial,
            end: task.fechaFinal
        });
    })
    return events;
}

export const parseConfirmedDealsToEvents = (deals: ConfirmedDeal[]): EventInput[] => {
    const events: EventInput[] = [];
    deals.map((deal) => {
        events.push({
            id: deal.dealId.toString(),
            title: deal.nombre,
            start: deal.fechaVisita,
            color: getColorEventByHorario(deal.horarioVisita),
        });
    })
    return events;
}

export const getColorEventByHorario = (horario: string) => {
    if(horario >= "15:00:00")
        return "purple";

    return "#3788d8";
}

export const parseTaskDate = (fecha: string, hora?: string): string => {
    return `${fecha.replaceAll("-", "/")}${hora ? " - " + hora : ""}`;
}

export const parseDateToInput = (fecha: string, hora?: string): string => {
    return `${fecha.replaceAll("/", "-")}${hora ? "T" + hora : ""}`;
}

export const reverseDate = (fecha: string): string => {
    const dateParts = fecha.split("/").reverse();
    return `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`
}